import { z } from "zod";

// 114 -- an invited school's admin/coach accepts or declines a fixture invite.
export const respondInvitationSchema = z.object({
  status: z.enum(["accepted", "declined"]),
});

export type RespondInvitationInput = z.infer<typeof respondInvitationSchema>;
